import { createStyles, IconButton, makeStyles, Theme } from "@material-ui/core";
import InfoIcon from '@material-ui/icons/Info';
import { useState } from "react";
import InfoDialog from "./InfoDialog";
import GoogleTagManager from "../../../gtm/GoogleTagManager";
import GtmInfoBtnId from "../../../gtm/types/GtmInfoBtnId";


const useStyles = makeStyles((theme: Theme) => createStyles({

    endIcon: {
        height: 20,
        // position: 'relative',
        // left: 3
        //height: 10
        width: 20,
    }

}));

type Param = {
    titel?: string,
    text: string,
    gtmId: GtmInfoBtnId
}

const InfoBtn: React.FC<Param> = ({ text, titel, gtmId }) => {
    const classes = useStyles();
    const [open, setOpen] = useState(false);

    const onClick = () => {
        const newOpen = !open;
        setOpen(newOpen);

        if (newOpen) {
            GoogleTagManager.fireEventBtnInfo(gtmId);
        }
    }

    return (<>
        <IconButton onClick={onClick} color='secondary' size='small'>
            <InfoIcon className={classes.endIcon} />
        </IconButton>
        <InfoDialog open={open} titel={titel} text={text} handleOnClose={onClick} />
    </>);
}

export default InfoBtn;